<div *ngIf="message !== undefined" class="pa-dialog-message-indicator-element">
    <div class="pa-dialog-message-indicator-line"></div>
    <div class="pa-dialog-message-indicator-message">{{ message }}</div>
    <div class="pa-dialog-message-indicator-line"></div>
</div>
